import { get_token ,get_user_details} from "@/router";
import Swal from 'sweetalert2';
/* global bootstrap */
export default {
  data() {
    return ({
      category_name: '',
      tag_name: new Map(), // Use Map instead of plain object
      categories: [],
      token_exists: false,
      fetched_categories: {},
      selectedCategoryId: null,
      user_details: {
        user_role: ''
      },
      edit_category: '',
      edit_category_id: '',
      reopenTagManagerModal: false,
      edit_tag_name: '',
      edit_tag_id: '',
    });
  },

  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetch_grouped_tags();
  },

  computed: {
    totalTags() {
      if (!Array.isArray(this.categories)) return 0;

      return this.categories.reduce((total, category) => {
        return total + (Array.isArray(category.tags) ? category.tags.length : 0);
      }, 0);
    }
  },

  methods: {
    openEditModal(categoryId, tag) {
      this.edit_category_id = categoryId;
      this.edit_tag_id = tag.id;
      this.edit_tag_name = tag.name;

      // Hide the main modal before showing edit modal
    const tagModal =bootstrap.Modal.getInstance(document.getElementById('categoryTagManagerModal'));
    if (tagModal) tagModal.hide();

    // Show the edit modal
    const editModal = new bootstrap.Modal(document.getElementById('editTagModal'));
    editModal.show();
    },
    openEditCategoryModal(category) {
    this.edit_category = category.name;
    this.edit_category_id = category.id;

    // Hide the main modal before showing edit modal
    const tagModal =bootstrap.Modal.getInstance(document.getElementById('categoryTagManagerModal'));
    if (tagModal) tagModal.hide();

    // Show the edit modal
    const editModal = new bootstrap.Modal(document.getElementById('editCategoryModal'));
    editModal.show();
  },
    fetch_grouped_tags() {
  this.isLoading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
    method: 'GET',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    success: (response) => {
      if (response.status === "success") {
        const tag_list = response.data.tags;

        // ✅ Use Map instead of plain object
        const grouped = new Map();

        tag_list.forEach(tag => {
          const catId = tag.tag_category.id;
          const catName = tag.tag_category.name;

          if (!grouped.has(catId)) {
            grouped.set(catId, {
              id: catId,
              name: catName,
              tags: []
            });
          }

          grouped.get(catId).tags.push({
            id: tag.id,
            name: tag.name
          });
        });

        this.categories = Array.from(grouped.values());


        // ✅ Initialize tag_name and selected_tags as Maps
        this.tag_name = new Map();
        this.selected_tags = new Map();

        this.categories.forEach(cat => {
          this.tag_name.set(cat.id, '');
          this.selected_tags.set(cat.name, null);
        });
      }
    },
    complete: () => {
      this.isLoading = false;
    }
  });
},


    getToken() {
      return get_token();
    },

    create_form_data(category = null) {
      if (!category) {
        category = this.categories.length > 0 ? this.categories[0] : null;
      }

      if (!category || !Array.isArray(category.tags)) {
        console.warn('No category or category.tags not found.');
        return null;
      }

      const formData = new FormData();


        formData.append('category_name', category.name);

      category.tags.forEach((tag, index) => {
        formData.append(`tags[${index}]`, tag.name);
      });

      return formData;
    },

   create_tag_category() {
    const category = this.categories.find(c => c.id === this.selectedCategoryId);

    if (!category || !category.tags || category.tags.length === 0) {
      Swal.fire({
        title: 'No tags to save',
        text: 'Please add at least one tag.',
        icon: 'info',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
      return;
    }

    const formData = new FormData();

    if (String(category.id).length < 10) {
      formData.append('category_id', category.id);
    } else {
      formData.append('category_name', category.name);
    }

    category.tags.forEach((tag, index) => {
      formData.append(`tags[${index}]`, tag.name);
    });

    $.ajax({
      type: "POST",
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_tag_category/`,
      data: formData,
      processData: false,
      contentType: false,
      headers: {
        'Authorization': `Token ${this.getToken()}`,
      },
      success: (response) => {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.message,
          showConfirmButton: false,
          timer: 2000,
          position: 'bottom-end',
          toast: true
        }).then(() => {
          $("#categoryTagManagerModal").modal("hide");
        });
      },
      error: (xhr) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: xhr.responseJSON?.message || 'Something went wrong.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
      }
    });
},

    handleKeyPress(type, categoryId = null) {
      if (type === 'category') {
        this.addCategory();
      } else if (type === 'tag') {
        this.addTag(categoryId);
      }
    },

     handleTagInputChange(categoryId, value) {
    this.tag_name.set(categoryId, value);
  },

    addCategory() {
      const name = this.category_name.trim();
      if (!name) return;

      const new_category = {
        id: Date.now(),
        name,
        tags: [],
      };

      this.categories.unshift(new_category);
      this.category_name = '';
    },

    delete_category(category_id) {

          Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            position: 'bottom-end',
            toast: true
          }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                type: "DELETE",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_tag_category/`,
                data: JSON.stringify({ category_id: parseInt(category_id) }),

                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                success: (response) => {
                  const status = response.status;
                  if (status === "success") {
                    this.categories = this.categories.filter(category => category.id !== category_id);
                    Swal.fire({
                      title: 'Deleted!',
                      text: 'The category has been deleted.',
                      icon: 'success',
                      showConfirmButton: false,
                      timer: 1000,
                      position: 'bottom-end',
                      toast: true
                    })
                  } else {
                    Swal.fire({
                      title: 'Failed!',
                      text: response.message || 'An error occurred. Please try again.',
                      icon: 'error',
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true
                    });
                  }
                },

                error: (xhr) => {

                  let message = "An error occurred. Please try again.";

                  // If backend returns JSON with a meaningful error
                  if (xhr.responseJSON && xhr.responseJSON.error) {
                    message = xhr.responseJSON.error;
                  }

                  Swal.fire({
                    title: 'Failed!',
                    text: message,
                    icon: 'error',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                  });
                }

              });
            }
          });
        },

        delete_tag(tag_id, category_id) {

          Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            position: 'bottom-end',
            toast: true
          }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                type: "DELETE",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_tag/`,
                data: JSON.stringify({ tag_id: parseInt(tag_id) }),

                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                success: (response) => {
                  const status = response.status;
                  if (status === "success") {
                    const category = this.categories.find(cat => cat.id === category_id);

                    if (category && category.tags) {
                      // ✅ Remove the deleted tag from the category
                      category.tags = category.tags.filter(tag => tag.id !== tag_id);
                    }

                    Swal.fire({
                      title: 'Deleted!',
                      text: 'The category has been deleted.',
                      icon: 'success',
                      showConfirmButton: false,
                      timer: 1000,
                      position: 'bottom-end',
                      toast: true
                    })
                  } else {
                    Swal.fire({
                      title: 'Failed!',
                      text: response.message || 'An error occurred. Please try again.',
                      icon: 'error',
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true
                    });
                  }
                },
                error: (xhr) => {

                let message = "An error occurred. Please try again.";
                // If backend returns JSON with a meaningful error
                if (xhr.responseJSON && xhr.responseJSON.error) {
                  message = xhr.responseJSON.error;
                }

                Swal.fire({
                  title: 'Failed!',
                  text: message,
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }

              });
            }
          });
        },

        update_tag_name(tag) {
          this.edit_tag_name = tag.name;
          this.edit_tag_id = tag.id;
        },

        update_tag() {
            const payload = {
                tag_id: this.edit_tag_id,
                tag_name: this.edit_tag_name
            };

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_tag/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                        const category = this.categories.find(cat => cat.id === this.edit_category_id);
          const tag = category.tags.find(t => t.id === this.edit_tag_id);
          if (tag) {
            tag.name = this.edit_tag_name;
          }

                        Swal.fire({
                            icon: 'success',
                            title: 'Updated',
                            text: 'Tag has been updated.',
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
$(`#editTagModal`).modal('hide');
                        $("#categoryTagManagerModal").modal("show");
                        })

                    }
                },
                error: () => {
                    Swal.fire({
                      title: "Error",
                      text: "Failed to update category.",
                      icon: "error",
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true
                    });
                }
            });
        },


update_category_name(category) {
  this.edit_category = category.name;
this.edit_category_id = category.id;

this.reopenTagManagerModal = true;

$("#categoryTagManagerModal").modal("hide");

        },
        update_category() {
            const payload = {
                category_id: this.edit_category_id,
                update_values: {
                    name: this.edit_category,
                },
            };

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_category/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                contentType: 'application/json',
                data: JSON.stringify(payload),
                success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                        const updated_category = this.categories.find(s => s.id === this.edit_category_id);
                        if (updated_category) {
                            updated_category.name = this.edit_category;
                        }

                        Swal.fire({
                            icon: 'success',
                            title: 'Updated',
                            text: 'Category has been updated.',
                            showConfirmButton: false,
                            timer: 1000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
$(`#editCategoryModal`).modal('hide');
                        $("#categoryTagManagerModal").modal("show");
                        })

                    }
                },
                error: () => {
                    Swal.fire({
                      title: "Error",
                      text: "Failed to update category.",
                      icon: "error",
                      position: 'bottom-end',
                      showConfirmButton: false,
                      timer: 3000,
                      toast: true
                    });
                }
            });
        },

  addTag(categoryId) {
    const tagName = (this.tag_name.get(categoryId) || '').trim();
    if (!tagName) return;

    const category = this.categories.find(c => c.id === categoryId);
    if (category) {
      category.tags.unshift({
        id: Date.now(),
        name: tagName,
      });

      this.tag_name.set(categoryId, '');
      this.selectedCategoryId = categoryId; // 👈 mark this category as active
    }
  },

    deleteTag(categoryId, tagId) {
      const category = this.categories.find(c => c.id === categoryId);
      if (category) {
        category.tags = category.tags.filter(tag => tag.id !== tagId);
      }
    },
  },
};